module.exports = __webpack_public_path__ + "img/loading_image.0e59d723.svg";